/* @flow */

import React from 'react';
import styled from 'styled-components';

const Content = styled.div`
  text-align: center;
  margin: 30px 0;
  img {
    max-width: 104px;
    height: auto;
  }
  > p {
    font-size: 14px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    font-weight: 500;
    color: rgba(33, 40, 51, 1);
    line-height: 18px;
    margin-top: 20px;
  }
`;

type Props = {
  msg: string,
};

const NoData = ({ msg }: Props) => (
  <Content>
    <img src="/static/images/common/norecord.svg" alt={msg} />
    <p>{msg}</p>
  </Content>
);

NoData.defaultProps = {
  msg: 'No Data!',
};

export default NoData;
